module.exports = __webpack_public_path__ + "static/media/oil1.c9823351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oil1.jpg
// module id = 5828
// module chunks = 0